import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "category", "unit"]

  connect() {
    this.handleGlobalKeydown = this.handleGlobalKeydown.bind(this)
    document.addEventListener("keydown", this.handleGlobalKeydown)
    this.element.addEventListener("submit", this.handleSubmit.bind(this))
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleGlobalKeydown)
  }

  handleGlobalKeydown(event) {
    if (event.key === "n" && !this.isInputFocused()) {
      event.preventDefault()
      this.inputTarget.focus()
    }
    if (event.key === "Escape" && this.isInputFocused()) {
      this.inputTarget.blur()
      this.inputTarget.value = ""
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.inputTarget.blur()
      this.inputTarget.value = ""
    }
  }

  handleSubmit(event) {
    const parsed = this.parseInput(this.inputTarget.value)
    if (!parsed.categoryHint && !parsed.unit) return

    event.preventDefault()

    if (parsed.categoryHint) {
      const matchedCategory = this.findMatchingCategory(parsed.categoryHint)
      if (matchedCategory) {
        this.categoryTarget.value = matchedCategory.value
      }
    }

    if (parsed.unit) {
      this.unitTarget.value = parsed.unit
    }

    this.inputTarget.value = parsed.name

    setTimeout(() => this.element.requestSubmit(), 0)
  }

  handleSubmitEnd(event) {
    this.submitting = false
    if (event.detail.success) {
      this.inputTarget.value = ""
      this.inputTarget.focus()
    }
  }

  parseInput(value) {
    let name = value
    let categoryHint = null
    let unit = null

    const categoryMatch = name.match(/\[([^\]]+)\]/)
    if (categoryMatch) {
      categoryHint = categoryMatch[1].trim().toLowerCase()
      name = name.replace(categoryMatch[0], "")
    }

    const unitMatch = name.match(/\(([^)]+)\)/)
    if (unitMatch) {
      unit = unitMatch[1].trim()
      name = name.replace(unitMatch[0], "")
    }

    return { name: name.trim(), categoryHint, unit }
  }

  findMatchingCategory(hint) {
    const options = Array.from(this.categoryTarget.options)
    return options.find(opt => {
      const text = opt.text.toLowerCase()
      return text.startsWith(hint) || text.includes(hint)
    })
  }

  isInputFocused() {
    const active = document.activeElement
    return active?.tagName?.toLowerCase() === "input" ||
           active?.tagName?.toLowerCase() === "textarea" ||
           active?.tagName?.toLowerCase() === "select"
  }
}
